import React, { useContext } from 'react';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Tooltip, message } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { LoyaltyActionType } from '../../../../types/loyaltyAction';
import { LOYALTY_ACTION } from '../../../../constants/define/translation';
import { deleteLoyaltyAction } from '../../../../repository/mytm/loyaltyAction/loyaltyActionRepository';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';

interface ActionsColumnProps {
  record: LoyaltyActionType;
  setIsOpenModal: Function;
  setDataRecord: Function;
  setLoading: Function;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(LOYALTY_ACTION);
  const userContext = useContext(UserContext);
  const { record, setIsOpenModal, setDataRecord, onRefresh, setLoading } = props;

  const handleDelete = async () => {
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('popup.delete')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setLoading && setLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              deleteLoyaltyAction(record?.id)
                .then(res => {
                  setLoading && setLoading(false);
                  message.success(t('message.success.deleteLoyalty'));
                })
                .catch(() => message.error(MESSAGE_ERROR.M02))
                .finally(() => {
                  onRefresh();
                });
            })
            .catch((e: any) => {
              setLoading && setLoading(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  const handleEdit = () => {
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('popup.edit')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setLoading && setLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setLoading && setLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              setLoading && setLoading(false);
              setDataRecord(record);
              setIsOpenModal(true);
            })
            .catch((e: any) => {
              setLoading && setLoading(false);
              message.error(e?.errorMessage);
            });
        }
      },
      onCancel() {
        setIsOpenModal(false);
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={t('table.tooltip.edit')}>
          <Button icon={<EditOutlined />} onClick={handleEdit} />
        </Tooltip>

        <Tooltip title={t('table.tooltip.delete')}>
          <Button icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />} onClick={handleDelete} />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div``;
